(function () {
  'use strict';

  if (window.__inesNewsletterSelectLoaded) return;
  window.__inesNewsletterSelectLoaded = true;

  var controls = new WeakMap();
  var personaCopies = new WeakSet();
  var openedControl = null;
  var nextId = 0;
  var indicatorResizeFallbacks = new Map();
  var indicatorResizeBound = false;

  function normalized(text) {
    return text.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLocaleLowerCase('fr');
  }

  function useSegments(select) {
    var dialog = select.closest('[data-newsletter-popup]');
    if (!dialog) return select.dataset.newsletterControls === 'segments';
    var requested = new URL(window.location.href).searchParams.get('newsletter_controls');
    var style = requested === 'segments' || requested === 'dropdown'
      ? requested : (dialog.dataset.controlsStyle === 'segments' ? 'segments' : 'dropdown');
    dialog.dataset.controlsStyle = style;
    return style === 'segments';
  }

  function selectionPrompt(form) {
    return form && form.querySelector('select[name="persona"]:not(:disabled)')
      ? 'Choisissez votre profil et votre classe.'
      : 'Choisissez votre classe.';
  }

  function clearResolvedSelectionNotice(select) {
    var form = select.form;
    var status = form && form.querySelector('[data-newsletter-status]');
    if (!status || status.textContent !== selectionPrompt(form)) return;
    var resolved = Array.from(form.querySelectorAll('select[data-newsletter-select]')).every(function (field) {
      return field.matches(':disabled') || field.validity.valid;
    });
    if (resolved) status.hidden = true;
  }

  function enhanceSegments(select, choices) {
    var id = (select.id || 'ines-newsletter-select-' + (++nextId)) + '-segments';
    var labels = Array.from(select.labels || []);
    var labelIds = labels.map(function (label, index) {
      if (!label.id) label.id = id + '-label-' + index;
      return label.id;
    });
    var heading = document.createElement('div');
    heading.className = 'ines-newsletter-segments__label';
    heading.setAttribute('aria-hidden', 'true');
    heading.textContent = labels.map(function (label) { return label.textContent.trim(); }).join(' ')
      || select.getAttribute('aria-label') || select.name;

    var group = document.createElement('div');
    group.id = id;
    group.className = 'ines-newsletter-segments';
    group.setAttribute('data-newsletter-segments', '');
    group.setAttribute('data-name', select.name);
    group.setAttribute('role', 'radiogroup');
    if (select.required) group.setAttribute('aria-required', 'true');
    if (labelIds.length) group.setAttribute('aria-labelledby', labelIds.join(' '));
    else if (select.hasAttribute('aria-labelledby')) group.setAttribute('aria-labelledby', select.getAttribute('aria-labelledby'));
    else group.setAttribute('aria-label', select.getAttribute('aria-label') || select.name);
    if (select.hasAttribute('aria-describedby')) group.setAttribute('aria-describedby', select.getAttribute('aria-describedby'));

    var indicator;
    if (select.dataset.newsletterControls === 'segments' && !select.closest('[data-newsletter-popup]')) {
      group.classList.add('ines-newsletter-segments--sliding');
      indicator = document.createElement('span');
      indicator.className = 'ines-newsletter-segments__indicator';
      indicator.setAttribute('data-newsletter-segment-indicator', '');
      indicator.setAttribute('aria-hidden', 'true');
      indicator.hidden = true;
      group.appendChild(indicator);
    }

    var buttons = choices.map(function (choice, index) {
      var button = document.createElement('button');
      button.type = 'button';
      button.id = id + '-option-' + index;
      button.className = 'ines-newsletter-segments__option';
      button.setAttribute('role', 'radio');
      button.setAttribute('aria-checked', 'false');
      button.setAttribute('data-value', choice.value);
      button.tabIndex = -1;
      button.textContent = choice.label;
      group.appendChild(button);
      return button;
    });
    select.parentNode.insertBefore(heading, select);
    select.parentNode.insertBefore(group, select);

    var control = { wrapper: group, trigger: buttons[0], close: function () {}, refresh: sync };
    controls.set(select, control);
    var indicatorFramePending = false;

    function updateIndicator() {
      var index = choices.findIndex(function (choice) { return choice.value === select.value; });
      var button = buttons[index];
      if (!button || !group.isConnected || choices[index].disabled
        || (choices[index].parentElement.tagName === 'OPTGROUP' && choices[index].parentElement.disabled)) {
        indicator.hidden = true;
        return;
      }
      var buttonBox = button.getBoundingClientRect();
      if (!buttonBox.width || !buttonBox.height) { indicator.hidden = true; return; }
      var groupBox = group.getBoundingClientRect();
      var style = window.getComputedStyle(group);
      // An absolute child's origin is the parent padding box, inside its border.
      group.style.setProperty('--ines-segment-x', (buttonBox.left - groupBox.left - (parseFloat(style.borderLeftWidth) || 0)) + 'px');
      group.style.setProperty('--ines-segment-y', (buttonBox.top - groupBox.top - (parseFloat(style.borderTopWidth) || 0)) + 'px');
      group.style.setProperty('--ines-segment-width', buttonBox.width + 'px');
      group.style.setProperty('--ines-segment-height', buttonBox.height + 'px');
      indicator.hidden = false;
    }

    function scheduleIndicator() {
      if (!indicator || indicatorFramePending) return;
      indicatorFramePending = true;
      var update = function () { indicatorFramePending = false; updateIndicator(); };
      if (typeof window.requestAnimationFrame === 'function') window.requestAnimationFrame(update);
      else setTimeout(update, 0);
    }

    function sync() {
      heading.textContent = labels.map(function (label) { return label.textContent.trim(); }).join(' ')
        || select.getAttribute('aria-label') || select.name;
      var disabled = select.matches(':disabled');
      var selectedIndex = choices.findIndex(function (choice) { return choice.value === select.value; });
      buttons.forEach(function (button, index) {
        var choice = choices[index];
        button.disabled = disabled || choice.disabled
          || (choice.parentElement.tagName === 'OPTGROUP' && choice.parentElement.disabled);
        button.setAttribute('aria-checked', String(index === selectedIndex));
      });
      var firstEnabled = buttons.findIndex(function (button) { return !button.disabled; });
      var focusIndex = selectedIndex >= 0 && !buttons[selectedIndex].disabled ? selectedIndex : firstEnabled;
      buttons.forEach(function (button, index) { button.tabIndex = index === focusIndex ? 0 : -1; });
      control.trigger = buttons[focusIndex >= 0 ? focusIndex : 0];
      if (disabled) group.setAttribute('aria-disabled', 'true');
      else group.removeAttribute('aria-disabled');
      if (select.required) group.setAttribute('aria-required', 'true');
      else group.removeAttribute('aria-required');
      if (select.validity.valid) group.removeAttribute('aria-invalid');
      clearResolvedSelectionNotice(select);
      scheduleIndicator();
    }

    function choose(index) {
      if (!buttons[index] || buttons[index].disabled) return;
      var changed = select.value !== choices[index].value;
      select.value = choices[index].value;
      sync();
      buttons[index].focus();
      if (changed) {
        select.dispatchEvent(new Event('input', { bubbles: true }));
        select.dispatchEvent(new Event('change', { bubbles: true }));
      }
    }

    buttons.forEach(function (button, index) {
      button.addEventListener('click', function () { choose(index); });
      button.addEventListener('keydown', function (event) {
        var key = event.key;
        if (key === 'Enter' || key === ' ') {
          event.preventDefault();
          choose(index);
          return;
        }
        var next = index;
        if (key === 'Home' || key === 'End') {
          event.preventDefault();
          next = key === 'Home'
            ? buttons.findIndex(function (candidate) { return !candidate.disabled; })
            : buttons.map(function (candidate) { return !candidate.disabled; }).lastIndexOf(true);
        } else if (key === 'ArrowRight' || key === 'ArrowDown' || key === 'ArrowLeft' || key === 'ArrowUp') {
          event.preventDefault();
          var direction = key === 'ArrowRight' || key === 'ArrowDown' ? 1 : -1;
          for (var step = 0; step < buttons.length; step++) {
            next = (next + direction + buttons.length) % buttons.length;
            if (!buttons[next].disabled) break;
          }
        } else return;
        choose(next);
      });
    });
    select.addEventListener('input', sync);
    select.addEventListener('change', sync);
    select.addEventListener('invalid', function (event) {
      event.preventDefault();
      group.setAttribute('aria-invalid', 'true');
      var form = select.form;
      var status = form && form.querySelector('[data-newsletter-status]');
      if (status) { status.textContent = selectionPrompt(form); status.hidden = false; }
      var firstInvalid = form && Array.from(form.querySelectorAll('select[data-newsletter-select]')).find(function (candidate) {
        return controls.has(candidate) && !candidate.disabled && !candidate.validity.valid;
      });
      (firstInvalid ? controls.get(firstInvalid).trigger : control.trigger).focus();
    });
    if (select.form) select.form.addEventListener('reset', function () { setTimeout(sync, 0); });
    if (indicator) {
      if (typeof ResizeObserver === 'function') {
        var resizeObserver = new ResizeObserver(scheduleIndicator);
        resizeObserver.observe(group);
      } else {
        indicatorResizeFallbacks.set(group, scheduleIndicator);
        if (!indicatorResizeBound) {
          indicatorResizeBound = true;
          window.addEventListener('resize', function () {
            indicatorResizeFallbacks.forEach(function (update, element) {
              if (element.isConnected) update();
              else indicatorResizeFallbacks.delete(element);
            });
          });
        }
      }
    }
    if (typeof MutationObserver === 'function') {
      var observer = new MutationObserver(sync);
      observer.observe(select, { attributes: true, subtree: true, attributeFilter: ['disabled', 'required'] });
      var ancestor = select.parentElement;
      while (ancestor) {
        if (ancestor.tagName === 'FIELDSET') observer.observe(ancestor, { attributes: true, attributeFilter: ['disabled'] });
        ancestor = ancestor.parentElement;
      }
    }
    sync();
    select.classList.add('ines-footer__newsletter-native');
    select.tabIndex = -1;
    select.setAttribute('aria-hidden', 'true');
  }

  function enhance(select) {
    if (controls.has(select)) return;
    var choices = Array.from(select.options).filter(function (option) {
      return !option.disabled && !(option.parentElement.tagName === 'OPTGROUP' && option.parentElement.disabled);
    });
    if (!choices.length) return;
    if (useSegments(select)) { enhanceSegments(select, choices); return; }

    var id = (select.id || 'ines-newsletter-select-' + (++nextId)) + '-custom';
    var wrapper = document.createElement('div');
    wrapper.className = 'ines-footer__newsletter-dropdown';
    wrapper.setAttribute('data-newsletter-dropdown', '');

    var trigger = document.createElement('button');
    trigger.type = 'button';
    trigger.id = id;
    trigger.className = 'ines-footer__newsletter-select';
    trigger.setAttribute('data-newsletter-select-trigger', '');
    trigger.setAttribute('role', 'combobox');
    trigger.setAttribute('aria-haspopup', 'listbox');
    trigger.setAttribute('aria-expanded', 'false');
    if (select.required) trigger.setAttribute('aria-required', 'true');
    if (select.disabled) trigger.disabled = true;
    if (select.hasAttribute('aria-describedby')) trigger.setAttribute('aria-describedby', select.getAttribute('aria-describedby'));

    var labelIds = Array.from(select.labels || []).map(function (label, index) {
      if (!label.id) label.id = id + '-label-' + index;
      label.htmlFor = id;
      return label.id;
    });
    if (labelIds.length) trigger.setAttribute('aria-labelledby', labelIds.join(' '));
    else if (select.hasAttribute('aria-labelledby')) trigger.setAttribute('aria-labelledby', select.getAttribute('aria-labelledby'));
    else trigger.setAttribute('aria-label', select.getAttribute('aria-label') || select.name);

    var value = document.createElement('span');
    value.setAttribute('data-newsletter-select-value', '');
    trigger.appendChild(value);
    var chevron = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
    chevron.setAttribute('viewBox', '0 0 12 8');
    chevron.setAttribute('width', '12');
    chevron.setAttribute('height', '8');
    chevron.setAttribute('aria-hidden', 'true');
    chevron.setAttribute('focusable', 'false');
    var chevronPath = document.createElementNS('http://www.w3.org/2000/svg', 'path');
    chevronPath.setAttribute('d', 'M1 1.5 6 6.5 11 1.5');
    chevronPath.setAttribute('fill', 'none');
    chevronPath.setAttribute('stroke', 'currentColor');
    chevronPath.setAttribute('stroke-width', '1.8');
    chevronPath.setAttribute('stroke-linecap', 'round');
    chevronPath.setAttribute('stroke-linejoin', 'round');
    chevron.appendChild(chevronPath);
    trigger.appendChild(chevron);

    var menu = document.createElement('ul');
    menu.id = id + '-listbox';
    menu.className = 'ines-footer__newsletter-menu';
    menu.setAttribute('role', 'listbox');
    menu.hidden = true;
    if (trigger.hasAttribute('aria-labelledby')) menu.setAttribute('aria-labelledby', trigger.getAttribute('aria-labelledby'));
    else menu.setAttribute('aria-label', trigger.getAttribute('aria-label'));
    trigger.setAttribute('aria-controls', menu.id);

    var options = choices.map(function (choice, index) {
      var option = document.createElement('li');
      option.id = id + '-option-' + index;
      option.className = 'ines-footer__newsletter-option';
      option.setAttribute('role', 'option');
      option.setAttribute('data-value', choice.value);
      option.setAttribute('aria-selected', 'false');
      option.textContent = choice.label;
      menu.appendChild(option);
      return option;
    });

    select.parentNode.insertBefore(wrapper, select);
    wrapper.appendChild(select);
    wrapper.appendChild(trigger);
    wrapper.appendChild(menu);

    var activeIndex = -1;
    var typed = '';
    var typedAt = 0;

    function highlight(index) {
      activeIndex = index;
      options.forEach(function (option, position) { option.classList.toggle('is-active', position === index); });
      if (!menu.hidden && options[index]) {
        trigger.setAttribute('aria-activedescendant', options[index].id);
        options[index].scrollIntoView({ block: 'nearest' });
      } else trigger.removeAttribute('aria-activedescendant');
    }

    function sync() {
      var selected = select.options[select.selectedIndex];
      value.textContent = selected ? selected.label : '';
      trigger.classList.toggle('is-placeholder', !select.value);
      options.forEach(function (option) { option.setAttribute('aria-selected', String(option.getAttribute('data-value') === select.value)); });
      if (select.validity.valid) trigger.removeAttribute('aria-invalid');
      clearResolvedSelectionNotice(select);
      if (!menu.hidden) highlight(choices.findIndex(function (choice) { return choice.value === select.value; }));
    }

    function close() {
      menu.hidden = true;
      trigger.setAttribute('aria-expanded', 'false');
      highlight(-1);
      typed = '';
      if (openedControl === control) openedControl = null;
    }

    function open(fromEnd) {
      if (select.disabled) return;
      if (openedControl && openedControl !== control) openedControl.close();
      openedControl = control;
      menu.hidden = false;
      trigger.setAttribute('aria-expanded', 'true');
      var selectedIndex = choices.findIndex(function (choice) { return choice.value === select.value; });
      highlight(selectedIndex >= 0 ? selectedIndex : (fromEnd ? choices.length - 1 : 0));
    }

    function choose(index) {
      if (!choices[index]) return;
      var changed = select.value !== choices[index].value;
      select.value = choices[index].value;
      sync();
      close();
      trigger.focus();
      if (changed) {
        select.dispatchEvent(new Event('input', { bubbles: true }));
        select.dispatchEvent(new Event('change', { bubbles: true }));
      }
    }

    var control = { wrapper: wrapper, trigger: trigger, close: close, refresh: sync };
    controls.set(select, control);
    trigger.addEventListener('click', function () { if (menu.hidden) open(false); else close(); });
    trigger.addEventListener('keydown', function (event) {
      var key = event.key;
      if (key === 'Tab') { close(); return; }
      if (key === 'Escape') { if (!menu.hidden) event.preventDefault(); close(); return; }
      if (key === 'Enter' || key === ' ') {
        event.preventDefault();
        if (menu.hidden) open(false); else choose(activeIndex);
        return;
      }
      if (key === 'ArrowDown' || key === 'ArrowUp') {
        event.preventDefault();
        if (menu.hidden) open(key === 'ArrowUp');
        else highlight(Math.max(0, Math.min(choices.length - 1, activeIndex + (key === 'ArrowDown' ? 1 : -1))));
        return;
      }
      if (key === 'Home' || key === 'End') {
        event.preventDefault();
        if (menu.hidden) open(false);
        highlight(key === 'Home' ? 0 : choices.length - 1);
        return;
      }
      if (key.length === 1 && !event.ctrlKey && !event.metaKey && !event.altKey) {
        event.preventDefault();
        if (menu.hidden) open(false);
        var now = Date.now();
        typed = (now - typedAt < 700 ? typed : '') + normalized(key);
        typedAt = now;
        var match = -1;
        for (var step = 1; step <= choices.length; step++) {
          var index = (activeIndex + step) % choices.length;
          if (normalized(choices[index].label).indexOf(typed) === 0) { match = index; break; }
        }
        if (match >= 0) highlight(match);
      }
    });
    options.forEach(function (option, index) {
      option.addEventListener('mousedown', function (event) { event.preventDefault(); });
      option.addEventListener('click', function () { choose(index); });
      // Scrolling the menu can fire mouseenter under a stationary pointer.
      // Only actual pointer movement should replace a keyboard highlight.
      option.addEventListener('pointermove', function () { if (!menu.hidden) highlight(index); });
    });

    select.addEventListener('input', sync);
    select.addEventListener('change', sync);
    select.addEventListener('invalid', function (event) {
      // Preserve the native required constraint while replacing its default
      // focus/error UI, which would target the visually clipped native select.
      event.preventDefault();
      trigger.setAttribute('aria-invalid', 'true');
      var form = select.form;
      var status = form && form.querySelector('[data-newsletter-status]');
      if (status) { status.textContent = selectionPrompt(form); status.hidden = false; }
      var firstInvalid = form && Array.from(form.querySelectorAll('select[data-newsletter-select]')).find(function (candidate) {
        return controls.has(candidate) && !candidate.disabled && !candidate.validity.valid;
      });
      (firstInvalid ? controls.get(firstInvalid).trigger : trigger).focus();
    });
    if (select.form) select.form.addEventListener('reset', function () { close(); setTimeout(sync, 0); });

    sync();
    // Hide the native UI only after the usable replacement and its handlers
    // exist. The original named control continues to own value/validation.
    select.classList.add('ines-footer__newsletter-native');
    select.tabIndex = -1;
    select.setAttribute('aria-hidden', 'true');
  }

  function bindPersonaCopy(select) {
    if (select.name !== 'persona' || personaCopies.has(select) || !select.form) return;
    var scope = select.closest('[data-newsletter-popup]') || select.form;
    var targets = Array.from(scope.querySelectorAll('[data-newsletter-copy-parent]'));
    if (!targets.length) return;
    personaCopies.add(select);

    function syncCopy() {
      var persona = select.value === 'parent' || select.value === 'eleve' ? select.value : 'neutral';
      targets.forEach(function (target) {
        var copy = target.getAttribute('data-newsletter-copy-' + persona);
        // Copy comes from Liquid's escaped theme settings and fixed inline-richtext,
        // never from the subscriber's input, URL or a remote response.
        if (copy !== null) {
          if (target.tagName === 'INPUT') target.setAttribute('placeholder', copy);
          else target.innerHTML = copy;
        }
      });
      select.form.querySelectorAll('select[data-newsletter-select]').forEach(function (field) {
        var control = controls.get(field);
        if (control && control.refresh) control.refresh();
      });
    }

    select.addEventListener('input', syncCopy);
    select.addEventListener('change', syncCopy);
    select.form.addEventListener('reset', function () { setTimeout(syncCopy, 0); });
    syncCopy();
  }

  function initialize(root) {
    if (root.matches && root.matches('select[data-newsletter-select]')) { enhance(root); bindPersonaCopy(root); }
    var selects = root.querySelectorAll('select[data-newsletter-select]');
    selects.forEach(enhance);
    selects.forEach(bindPersonaCopy);
  }

  document.addEventListener('click', function (event) {
    if (openedControl && !openedControl.wrapper.contains(event.target)) openedControl.close();
  });
  document.addEventListener('shopify:section:load', function (event) { initialize(event.target); });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { initialize(document); }, { once: true });
  else initialize(document);
})();
